module.exports = __webpack_public_path__ + "img/audio.86d49382.png";